import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const MarketCapLossesComponent = (props) => (

    <div>
        <ReportSectionHeader>
			{props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4? "Rule 10b-5 Exposure: Market Capitalization Losses on High-Risk Adverse Events":"Market Capitalization Losses on Alleged Corrective Disclosures"}
        	
        </ReportSectionHeader>
        <ReportTable
            settings={props.isDandO === "true" ?[
                {
                    header: 'Trading Day',
                    accessor: 'date',
                    tooltip: 'Trading days presented below are two consecutive trading days where the latter shows stock price impact stemming from the high-risk adverse events.'
                },
                {
                    header: 'Closing Stock Price',
                    accessor: 'closingPrice',
                    dollarValue: true,
                    centerRightJustified: true,
                    round2Decimals: true
                },
                {
                    header: 'Shares Outstanding~(000s)',
                    accessor: 'sharesOutStanding',
                    dollarValue: false,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    round2whole: true
                },
                {
                    header: 'Approx. Market Cap.~(000s)', 
                    accessor: 'approxMarketCap',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: 'Approx. Market Cap. Losses~(000s)',
                    accessor: 'approxMarketCapLoss',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    tooltip: 'Market Cap. Losses are equal to the changes in market cap. on trading days affected by the high-risk adverse event. If the change (daily log return) in stock price, after controlling for market and industry forces is statistically significant at the 95% Confidence Level, the trading day that corresponds to the corrective event will be presented here.'
                }
            ] 
            :
        	[
                {
                    header: 'Trading Day',
                    accessor: 'date',
                    tooltip: 'Trading days presented below are two consecutive trading days where the latter shows stock price impact stemming from the corrective event.'
                },
                {
                    header: 'Closing Stock Price',
                    accessor: 'closingPrice',
                    dollarValue: true,
                    centerRightJustified: true,
                    round2Decimals: true
                },
                {
                    header: 'Shares Outstanding~(000s)',
                    accessor: 'sharesOutStanding',
                    dollarValue: false,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    round2whole: true
                },
                {
                    header: 'Approx. Market Cap.~(000s)', accessor: 'approxMarketCap',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: 'Approx. Market Cap. Losses~(000s)',
                    accessor: 'approxMarketCapLoss',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    tooltip: 'Market Cap. Losses are equal to the changes in market cap. on trading days affected by the corrective event. If the change (daily log return) in stock price, after controlling for market and industry forces is statistically significant at the 95% Confidence Level, the trading day that corresponds to the corrective event will be presented here.'
                }
            ]}
            data={props.marketCapitalizationLosses}
            name={"marketCapLosses"}
            accumulator={"approxMarketCapLoss"}
            accumulatorDisplay={props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4?"Total Rule 10b-5 Exposure" : "Total Approx. Market Cap. Losses"}
        />
        <div class="AceBoldText">
		* Bold <span class="AceItalicsText">records indicate {props.isDandO === "true" || props.claimTypeId === 3 || props.claimTypeId === 4 ? "Adverse Corporate Event" : "Alleged Corrective Disclosure" }</span>
		</div>

    </div>
);


export default MarketCapLossesComponent;


// WEBPACK FOOTER //
// ./src/common/components/MarketCapLosses/MarketCapLossesComponent.js